// removed by extract-text-webpack-plugin
module.exports = {"base":"OrangeTimer_base--1qaWO","base__isSmall":"OrangeTimer_base__isSmall--Ry5EO","baseIsSmall":"OrangeTimer_base__isSmall--Ry5EO","base__isBig":"OrangeTimer_base__isBig--3K852","baseIsBig":"OrangeTimer_base__isBig--3K852","showGlow":"OrangeTimer_showGlow--3T8ix"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/OrangeTimer/OrangeTimer.scss
// module id = 2347
// module chunks = 11